<template>
    <div class="ticket-packages-header">
        <strong>{{ totalTickets }} {{ trans.ticket_packages }}</strong>

        <div class="sort-by">
            <label class="sort-select" for="sort-options">
                <span class="sort-select-icon">
                    <svg
                        width="5"
                        height="8"
                        viewBox="0 0 5 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.312511 2.99986H4.68728C4.77191 2.99986 4.84517 2.9669 4.90699 2.90092C4.96878 2.83496 4.9998 2.75685 4.9998 2.66657C4.9998 2.57629 4.9688 2.49822 4.90699 2.43217L2.7196 0.0989423C2.6578 0.0330537 2.58459 0 2.4999 0C2.41522 0 2.342 0.0330537 2.28015 0.0989423L0.0927581 2.43217C0.0309023 2.49815 0 2.57629 0 2.66657C0 2.75683 0.0309023 2.83496 0.0927581 2.90092C0.154682 2.9669 0.227894 2.99986 0.312511 2.99986Z"
                            fill="#110024"
                        />
                        <path
                            d="M4.68749 4.99989L0.312724 4.99989C0.228089 4.99989 0.154827 5.03286 0.0930054 5.09884C0.0312178 5.1648 0.000195744 5.24291 0.000195736 5.33318C0.000195728 5.42346 0.0312006 5.50154 0.0930054 5.56759L2.2804 7.90081C2.3422 7.9667 2.41541 7.99976 2.5001 7.99976C2.58478 7.99976 2.658 7.9667 2.71985 7.90081L4.90724 5.56759C4.9691 5.50161 5 5.42346 5 5.33318C5 5.24293 4.9691 5.1648 4.90724 5.09884C4.84532 5.03286 4.77211 4.99989 4.68749 4.99989Z"
                            fill="#110024"
                        />
                    </svg>
                </span>

                <span class="sort-select-label">{{
                    sortOptions.find(option => option.value === selectedSort)
                        .label
                }}</span>

                <select
                    id="sort-options"
                    v-model="selectedSort"
                    @change="handleSortChange"
                >
                    <option v-for="option in sortOptions" :value="option.value">
                        {{ option.label }}
                    </option>
                </select>
            </label>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../sass/variables";

.ticket-packages-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 0;
    font-size: 16px;
    color: $color2-text-primary;
}

.sort-by {
    display: flex;
    align-items: center;
    justify-content: center;
}

.sort-select {
    position: relative;
    margin: 0;

    select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background: transparent;
        padding: 4px 32px 4px 8px;
        font-size: 0;
        outline: none;
        cursor: pointer;

        opacity: 0;
        border: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        &:hover {
            border-color: $color2-gray-medium;
        }

        &:focus {
            border-color: $color2-primary;
        }
    }

    .sort-select-icon {
        color: $color2-text-secondary;
        pointer-events: none;

        svg {
            width: 16px;
            height: 12px;
        }
    }

    .sort-select-label {
        font-size: 14px;
        font-weight: 600;
        color: $color2-text-primary;
    }
}
</style>

<script>
export default {
    props: {
        totalTickets: {
            type: Number,
            required: true
        },
        trans: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedSort: "most-relevant",
            sortOptions: [
                {
                    label: this.trans.sort.most_relevant,
                    value: "most-relevant"
                },
                {
                    label: this.trans.sort.price_low_high,
                    value: "price-low-high"
                },
                {
                    label: this.trans.sort.price_high_low,
                    value: "price-high-low"
                },
                {
                    label: this.trans.sort.date,
                    value: "date"
                }
            ]
        };
    },
    methods: {
        handleSortChange() {
            this.$emit("sort-change", this.selectedSort);
        }
    }
};
</script>
